<mat-card [class.Selected]="isSelected()">
  @let attributeValue = gemstoneAttributeValue();
  <mat-card-content>
    <button (click)="cardClicked()" mat-flat-button>
      <div [class.Selected]="isSelected()" class="Flexbox Flexbox--column Gap--smaller ButtonContent">
        @if (attributeValue) {
          <div class="ImageContainer">
            <img [src]="getThumbnail(attributeValue)">
          </div>
        }
        <div class="Flexbox ButtonName">
          <span>
            @if (attributeValue) {
              {{ attributeValue.displayName }}
            }
          </span>
        </div>
      </div>
    </button>
  </mat-card-content>
</mat-card>